import React, { lazy } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';

import AuthorizationWrap from '../hoc/AuthorizeWrap';

// Containers
const Layout = lazy(() => import('../shared/Layout'));
const Login = lazy(() => import('../pages/authentication/Login'));
const InquirySendEmails = lazy(() => import('../pages/inquiry/InquirySendEmails'));


const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

function LayoutNavigation() {

    return (
        <HashRouter>
            <React.Suspense fallback={loading}>
                <Switch>
                    <Route exact path="/login" name="Login Page" render={props => <Login />} />
                    <Route exact path="/inquirySendEmail/:id/:id" name="Inquiry Email" render={props => <InquirySendEmails />} />
                    <AuthorizationWrap>
                        <Route path="/" name="Layout" render={props => <Layout {...props} />} />
                    </AuthorizationWrap>
                </Switch>
            </React.Suspense>
        </HashRouter>
    );
}

export default LayoutNavigation;
